<template>
  <TopGradientBlockLayout class="flex justify-center flex-wrap w-1/2 mx-auto">
    <div class="w-full text-center text-xl font-bold text-text leading-tight mb-12">Начните инвестировать!</div>
    <BaseButton theme="red" @click="$router.push({name:'invest-profile'})">Создать первый портфель</BaseButton>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "StartInvesting",
  components: {BaseButton, TopGradientBlockLayout}
}
</script>

<style scoped>

</style>